import { useState, useEffect } from 'react';
import { withLoading } from '@front-activerse/common-components';
import Layout from '../Layout/Layout';
import { deepClone } from '@front-activerse/common-components';
import { Container, Row, Col, Collapse, Button, Modal } from 'reactstrap';
import { formatMediumDate } from '@front-activerse/common-components';
import AchievementsPlaceholder from './AchievementsPlaceholder';
import TitleBar from '../Layout/TitleBar';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const DATA_SOURCE = {
  WORKOUTS_DONE: 'WORKOUTS_DONE',
  WORKOUT_DONE_DATES: 'WORKOUT_DONE_DATES',
  IF_DONE: 'IF_DONE',
  HYDRATION_GOALS_ACHIEVED: 'HYDRATION_GOALS_ACHIEVED',
};

const getIndexOfitemInArray = (array, item) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < array.length; i++) {
    if (array[i][0].id === item[0].id) {
      return i;
    }
  }
  return null;
};

const Achievements = ({ achievements }) => {
  // move DATA_SOURCE.WORKOUT_DONE_DATES achievements after DATA_SOURCE.WORKOUT_DONE
  const filteredAchievements = achievements.filter(
    (achievement) => achievement.rule.datasource !== DATA_SOURCE.WORKOUT_DONE_DATES
  );
  const filteredAchievements2 = achievements.filter(
    (achievement) => achievement.rule.datasource === DATA_SOURCE.WORKOUT_DONE_DATES
  );
  filteredAchievements.push(...filteredAchievements2);

  const { t } = useTranslator();
  const [groupedAchievements, setGroupedAchievements] = useState({});
  const [collapse, setCollapse] = useState({});
  const [pickedAchievement, setPickedAchievement] = useState(null);

  const {
    images: { achievementBg },
    svgInline: { DownArrow },
  } = useAppContext();

  useEffect(() => {
    setGroupedAchievements(groupByCategories());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Object.entries(groupedAchievements).forEach(([, subCategories]) => {
      Object.entries(subCategories).forEach(([subCategory]) => {
        setCollapse({
          ...collapse,
          [subCategory]: false,
        });
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupedAchievements]);

  // eslint-disable-next-line class-methods-use-this
  const lastRevealedAchievement = (achievements) => {
    let referenceDate = new Date('2000-01-01');
    let lastRevealedAchievement = achievements[0].id;

    achievements.forEach((achievement) => {
      if (achievement.isAchieved) {
        const date = new Date(achievement.userAchievement[0].createdAt);

        if (date >= referenceDate) {
          referenceDate = date;
          lastRevealedAchievement = achievement.id;
        }
      }
    });
    return lastRevealedAchievement;
  };

  const groupByCategories = () => {
    const groupedMainCategory = groupBy(filteredAchievements, 'groupIdentifier');

    const groupedWithSubCategory = {};

    Object.entries(groupedMainCategory).forEach(([key, value]) => {
      groupedWithSubCategory[key] = groupBy(value, 'rule', 'datasource');
    });

    const achievementsSortedBySpecificValue = Object.keys(groupedWithSubCategory)

      .sort((a, b) => {
        const achievementsOrder = ['workouts-done', 'if-done', 'hydration-done'];

        const aAchievementIndex = achievementsOrder.indexOf(a);
        const bAchievementIndex = achievementsOrder.indexOf(b);

        if (aAchievementIndex === bAchievementIndex) return a - b;

        return aAchievementIndex - bAchievementIndex;
      })
      .reduce((accumulator, key) => {
        accumulator[key] = groupedWithSubCategory[key];

        return accumulator;
      }, {});

    return achievementsSortedBySpecificValue;
  };

  const groupBy = (array, key, key2) => {
    const list = {};

    if (key2) {
      // eslint-disable-next-line array-callback-return
      array.map((el) => {
        list[el[key][key2]] = array.filter((e) => e[key][key2] === el[key][key2]);
      });
    } else {
      // eslint-disable-next-line array-callback-return
      array.map((el) => {
        list[el[key]] = array.filter((e) => e[key] === el[key]);
      });
    }

    return list;
  };

  const chunkArray = (array, perChunk) => {
    const result = array.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / perChunk);

      if (!resultArray[chunkIndex]) {
        // eslint-disable-next-line no-param-reassign
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);

    return result;
  };

  const toggle = (collapseCategory) => {
    setCollapse({
      ...collapse,
      [collapseCategory]: !collapse[collapseCategory],
    });
  };

  const handleModal = (achievement) => {
    if (!pickedAchievement) {
      setPickedAchievement(achievement);
    } else {
      setPickedAchievement(null);
    }
  };

  const getFirstsElementsOfArray = (array, numberOfFirstElemements) => {
    return array.slice(0, numberOfFirstElemements);
  };

  const renderCategoryTitle = (category) => {
    if (category === 'workouts-done') {
      return t('allAchievements.categoryWorkouts.title');
    }
    if (category === 'if-done') {
      return t('allAchievements.categoryFasting.title');
    }
    if (category === 'hydration-done') {
      return t('allAchievements.categoryHydration.title');
    }

    return '';
  };

  const renderSubCategoryTitle = (subCategory) => {
    if (subCategory === DATA_SOURCE.WORKOUTS_DONE) {
      return t('allAchievements.workoutsBox.workoutsCompleted.title');
    }

    if (subCategory === DATA_SOURCE.WORKOUT_DONE_DATES) {
      return t('allAchievements.workoutsBox.occasionalWorkoutsCompleted.title');
    }

    if (subCategory === DATA_SOURCE.HYDRATION_GOALS_ACHIEVED) {
      return t('allAchievements.hydrationBox.dailyGoalsReached.title');
    }

    if (subCategory === DATA_SOURCE.IF_DONE) {
      return t('allAchievements.fastingBox.dailyGoalsReached.title');
    }

    return '';
  };

  const renderSubCategorySubTitle = (subCategory) => {
    if (subCategory === DATA_SOURCE.WORKOUTS_DONE) {
      return '';
    }

    if (subCategory === DATA_SOURCE.WORKOUT_DONE_DATES) {
      return t('allAchievements.workoutsBox.occasionalWorkoutsCompleted.description');
    }

    if (subCategory === DATA_SOURCE.HYDRATION_GOALS_ACHIEVED) {
      return '';
    }

    if (subCategory === DATA_SOURCE.IF_DONE) {
      return '';
    }

    return '';
  };

  const renderPrevAchievements = (array) => {
    return array.map((item) => {
      return item.map((achievement) => {
        return (
          <Col xs="4" md="2" key={achievement.id}>
            <div
              className={achievement.isAchieved ? 'achievement is-achieved' : 'achievement'}
              onClick={() => handleModal(achievement)}
            >
              <img src={achievement.thumbnailUrl} className="img-fluid" alt={achievement.name} />
              <p className="mb-0 description-small">{achievement.name}</p>
            </div>
          </Col>
        );
      });
    });
  };

  const renderFirstsAchievements = (achievements, firstElemenetsToRender) => {
    const firstAchievements = getFirstsElementsOfArray(achievements, firstElemenetsToRender);

    return firstAchievements.map((achievement) => {
      return (
        <Col xs="4" md="2" key={achievement.id}>
          <div
            className={achievement.isAchieved ? 'achievement is-achieved' : 'achievement'}
            onClick={() => handleModal(achievement)}
          >
            <img src={achievement.thumbnailUrl} className="img-fluid" alt={achievement.name} />
            <p className="mb-0 description-small">{achievement.name}</p>
          </div>
        </Col>
      );
    });
  };

  const getAchievementsToRenders = (
    chunkedArray,
    rowWithLastAchievements,
    indexOfLastAchievements
  ) => {
    if (indexOfLastAchievements % 2 !== 0) {
      if (rowWithLastAchievements[rowWithLastAchievements.length - 1].isAchieved) {
        const nextRow = chunkedArray[indexOfLastAchievements + 1] || [];
        const prevAchievements = chunkedArray.slice(0, indexOfLastAchievements);
        const nextAchievements = chunkedArray.slice(indexOfLastAchievements + 2);
        const firstRenderArray = [...rowWithLastAchievements, ...nextRow];
        return {
          prevAchievements,
          firstRenderArray,
          nextAchievements,
        };
      }
      const prevAchievements = chunkedArray.slice(0, indexOfLastAchievements - 1);
      const nextAchievements = chunkedArray.slice(indexOfLastAchievements + 1);

      const prevRow = chunkedArray[indexOfLastAchievements - 1];
      const firstRenderArray = [...prevRow, ...rowWithLastAchievements];

      return { prevAchievements, firstRenderArray, nextAchievements };
    }
    if (indexOfLastAchievements === 0) {
      const prevAchievements = [];
      const nextAchievements = chunkedArray.slice(indexOfLastAchievements + 2);
      const nextRow = chunkedArray[indexOfLastAchievements + 1] || [];
      const firstRenderArray = [...rowWithLastAchievements, ...nextRow];

      return { prevAchievements, firstRenderArray, nextAchievements };
    }
    if (indexOfLastAchievements === chunkedArray.length - 1) {
      const prevRow = chunkedArray[indexOfLastAchievements - 1];
      const nextAchievements = [];
      const prevAchievements = chunkedArray.slice(0, indexOfLastAchievements - 1);
      const firstRenderArray = [...prevRow, ...rowWithLastAchievements];
      return { prevAchievements, firstRenderArray, nextAchievements };
    }
    const nextRow = chunkedArray[indexOfLastAchievements + 1] || [];
    const prevAchievements = chunkedArray.slice(0, indexOfLastAchievements);
    const nextAchievements = chunkedArray.slice(indexOfLastAchievements + 2);

    const firstRenderArray = [...rowWithLastAchievements, ...nextRow];

    return { prevAchievements, firstRenderArray, nextAchievements };
  };

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('allAchievements.navbarTitle')}</TitleBar>
      <div className="page-template-achievements full-height3">
        <Container>
          <Modal
            isOpen={Boolean(pickedAchievement)}
            toggle={() => handleModal()}
            centered
            className="achievement-modal"
          >
            {pickedAchievement ? (
              <section
                className={
                  pickedAchievement.isAchieved
                    ? 'featured-achievement is-achieved'
                    : 'featured-achievement'
                }
              >
                {pickedAchievement.isAchieved && <img className="bg" src={achievementBg} alt="" />}

                <img
                  src={pickedAchievement.imageUrl}
                  className="img-fluid mt-xxl"
                  alt={pickedAchievement.name}
                />
                <h4 className="title-small semi-bold mb-s position-relative">
                  {pickedAchievement.name}
                </h4>

                {pickedAchievement.isAchieved ? (
                  <>
                    <p className="small text-text-variant-color mb-0">
                      {t('achievementPopup.earnedBadge')}
                    </p>

                    {[...pickedAchievement.userAchievement].reverse().map((item) => (
                      <p key={item.id} className="small mt-s mb-0">
                        {formatMediumDate(new Date(item.createdAt))}
                      </p>
                    ))}

                    {/* {formatMediumDate(new Date(pickedAchievement.userAchievement[0].createdAt))} */}
                  </>
                ) : (
                  <p className="small text-text-variant-color mb-0">
                    {t('achievementPopup.notAchievedYet')}
                  </p>
                )}

                <Button className="w-100 mt-xl" color="primary" onClick={() => handleModal()}>
                  {t('allAchievements.achievementInfoPopup.ok.button')}
                </Button>
              </section>
            ) : (
              ''
            )}
          </Modal>
          <section>
            <Row>
              <Col md={{ size: 10, offset: 1 }}>
                {Object.entries(groupedAchievements).map(([category, subCategories]) => {
                  const categoryTitle = renderCategoryTitle(category);
                  return (
                    <div className="achieve-wrapper" key={category}>
                      <h2 className="title-medium semi-bold mb-m">{categoryTitle}</h2>

                      {Object.entries(subCategories).map(([subCategory, achievements]) => {
                        const subCategoryTitle = renderSubCategoryTitle(subCategory);
                        const subCategorySubTitle = renderSubCategorySubTitle(subCategory);

                        const lastRevealedId = lastRevealedAchievement(achievements);

                        const chunkedArray = deepClone(chunkArray(achievements, 3));

                        const rowWithLastAchievements = deepClone(
                          chunkedArray.find((array) =>
                            array.find((item) => item.id === lastRevealedId)
                          )
                        );

                        const indexOfLastAchievements = getIndexOfitemInArray(
                          chunkedArray,
                          rowWithLastAchievements
                        );

                        // For WORKOUT_DONE_DATES, show only achieved achievements
                        if (subCategory === DATA_SOURCE.WORKOUT_DONE_DATES) {
                          // Filter only achieved achievements and sort from newest to oldest
                          const achievedAchievements = achievements
                            .filter((achievement) => achievement.isAchieved)
                            .sort((a, b) => {
                              const dateA = new Date(a.userAchievement[0].createdAt);
                              const dateB = new Date(b.userAchievement[0].createdAt);
                              return dateB - dateA;
                            });

                          return (
                            <div className="achieve-box" key={subCategory}>
                              <p className="mb-xxs">{subCategoryTitle}</p>
                              <p className="mb-xl text-text-variant-color small">
                                {subCategorySubTitle}
                              </p>

                              <Row>
                                {renderFirstsAchievements(achievedAchievements.slice(0, 6))}
                              </Row>
                              <Collapse isOpen={collapse[subCategory]}>
                                <Row>{renderFirstsAchievements(achievedAchievements.slice(6))}</Row>
                              </Collapse>

                              {achievedAchievements.length > 6 && (
                                <div className="text-center">
                                  <Button
                                    color="link"
                                    className="px-0 py-0"
                                    size="sm"
                                    onClick={() => toggle(subCategory)}
                                  >
                                    {collapse[subCategory]
                                      ? t('allAchievements.achievementsBox.hide.button')
                                      : t('allAchievements.achievementsBox.showAll.button')}
                                    <span
                                      className={
                                        collapse[subCategory]
                                          ? 'dropdown-arrow ms-2 up'
                                          : 'dropdown-arrow ms-2'
                                      }
                                    >
                                      <span className="SVGInline">
                                        <DownArrow />
                                      </span>
                                    </span>
                                  </Button>
                                </div>
                              )}
                            </div>
                          );
                        }

                        // For other categories, use the existing logic
                        const { prevAchievements, firstRenderArray, nextAchievements } =
                          getAchievementsToRenders(
                            chunkedArray,
                            rowWithLastAchievements,
                            indexOfLastAchievements
                          );

                        return (
                          <div className="achieve-box" key={subCategory}>
                            <p className="mb-xxs">{subCategoryTitle}</p>
                            <p className="mb-xl text-text-variant-color small">
                              {subCategorySubTitle}
                            </p>

                            <Collapse isOpen={collapse[subCategory]}>
                              <Row>{renderPrevAchievements(prevAchievements)}</Row>
                            </Collapse>
                            <Row>{renderFirstsAchievements(firstRenderArray)}</Row>
                            <Collapse isOpen={collapse[subCategory]}>
                              <Row>{renderPrevAchievements(nextAchievements)}</Row>
                            </Collapse>

                            {achievements.length > 6 && (
                              <div className="text-center">
                                <Button
                                  color="link"
                                  className="px-0 py-0"
                                  size="sm"
                                  onClick={() => toggle(subCategory)}
                                >
                                  {collapse[subCategory]
                                    ? t('allAchievements.achievementsBox.hide.button')
                                    : t('allAchievements.achievementsBox.showAll.button')}
                                  <span
                                    className={
                                      collapse[subCategory]
                                        ? 'dropdown-arrow ms-2 up'
                                        : 'dropdown-arrow ms-2'
                                    }
                                  >
                                    <span className="SVGInline">
                                      <DownArrow />
                                    </span>
                                  </span>
                                </Button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </Col>
            </Row>
          </section>
        </Container>
      </div>
    </Layout>
  );
};

export default withLoading(Achievements, AchievementsPlaceholder);
